import Vue from "vue";
const vm = Vue.prototype;

export const state = () => ({
  paids2kurs: [],
  paids1kurs: [],
  paids: [],
});

export const mutations = {
  SET_PAIDS(state, payload) {
    state.paids = vm.$toArray(payload);
  },

  SET_PAIDS_1KURS(state, payload) {
    state.paids1kurs = vm.$toArray(payload);
  },

  SET_PAIDS_2KURS(state, payload) {
    state.paids2kurs = vm.$toArray(payload);
  },
};

export const actions = {
  async INIT_PAIDS({ commit }) {
    let status = false;
    const data = await vm.$axios.$get("admin/statistics/contract/paid/0");

    status = data != null;
    commit("SET_PAIDS", data);

    return status;
  },

  async INIT_PAIDS_1KURS({ commit }) {
    let status = false;
    const data = await vm.$axios.$get("admin/statistics/contract/paid/1");

    status = data != null;
    commit("SET_PAIDS_1KURS", data);

    return status;
  },

  async INIT_PAIDS_2KURS({ commit }) {
    let status = false;
    const data = await vm.$axios.$get("admin/statistics/contract/paid/2");

    status = data != null;
    commit("SET_PAIDS_2KURS", data);

    return status;
  },
};

export const getters = {
  GET_PAIDS_1KURS: (state) => state.paids1kurs,
  GET_PAIDS_2KURS: (state) => state.paids2kurs,
  GET_PAIDS: (state) => state.paids,
};
